import { memo } from "react";

import { ApplyPriceText } from "../../components";

import type { QueryData } from "../../../model";

type Props = {
	options: QueryData["aliveItemsPerReservation"]["options"];
};

export const ListOfNonDateOptionCompositions = memo(({ options }: Props) => {
	return (
		<>
			{options.map((option, index) => {
				const optionText = `${option.name} x ${option.amount}個`;
				return (
					<div key={index} className="space-y-4">
						<p>{optionText}</p>

						<ApplyPriceText
							price={option.price}
							discountedPrice={option.discountedPrice ?? undefined}
							hostInsertedPrice={option.hostInsertedPrice ?? undefined}
						/>
					</div>
				);
			})}
		</>
	);
});
